import { render, staticRenderFns } from "./ContractDisplay.vue?vue&type=template&id=6de7cbf2&"
import script from "./ContractDisplay.vue?vue&type=script&lang=js&"
export * from "./ContractDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6de7cbf2')) {
      api.createRecord('6de7cbf2', component.options)
    } else {
      api.reload('6de7cbf2', component.options)
    }
    module.hot.accept("./ContractDisplay.vue?vue&type=template&id=6de7cbf2&", function () {
      api.rerender('6de7cbf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/contracts/ContractDisplay.vue"
export default component.exports